import React, { useMemo, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import request from '../../../../request';
import Notify from '../../../compartidos/Notify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faEye, faEyeSlash, faLock, faShieldAlt } from '@fortawesome/free-solid-svg-icons';

const ResetPassword = ({ ipserv, token, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        password: '',
        repeatPassword: ''
    });

    const passwordScore = useMemo(() => {
        let score = 0;
        if (formData.password.length >= 8) score += 1;
        if (/[A-Z]/.test(formData.password)) score += 1;
        if (/[0-9]/.test(formData.password)) score += 1;
        if (/[^A-Za-z0-9]/.test(formData.password)) score += 1;
        return score;
    }, [formData.password]);

    const validatePassword = () => {
        if (!token) return 'El enlace de restablecimiento no es valido.';
        if (formData.password.length < 8) return 'La contraseña debe tener al menos 8 caracteres.';
        if (formData.password !== formData.repeatPassword) return 'Las contraseñas no coinciden.';
        return null;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const error = validatePassword();
        if (error) {
            Notify({ type: 'fail', text: error });
            return;
        }

        setLoading(true);
        const API_BASE = ipserv || process.env.REACT_APP_API_URL || 'http://localhost:5000/';

        request.Post(API_BASE + 'auth/reset-password', {
            token,
            password: formData.password
        }, r => {
            if (r.success) {
                Notify({ type: 'success', text: 'Contraseña actualizada correctamente.' });
                if (onSuccess) onSuccess();
            } else {
                Notify({ type: 'fail', text: r.msg || 'No pudimos actualizar la contraseña.' });
            }
            setLoading(false);
        }, 'json', err => {
            Notify({ type: 'fail', text: err?.msg || 'Error de conexion.' });
            setLoading(false);
        });
    };

    return (
        <div className="w-100">
            <div className="auth-mini-icon mb-3">
                <FontAwesomeIcon icon={faShieldAlt} />
            </div>
            <h1 className="auth-title">Nueva contraseña</h1>
            <p className="auth-subtitle">
                Crea una clave segura para volver a ingresar a DataManager.
            </p>

            {!token ? (
                <div className="auth-note auth-note-danger">
                    El enlace no contiene un token valido. Solicita un nuevo correo de recuperacion.
                </div>
            ) : (
                <form onSubmit={handleSubmit}>
                    <div className="auth-input-group">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            className="auth-input"
                            placeholder="Nueva contraseña"
                            value={formData.password}
                            onChange={e => setFormData({ ...formData, password: e.target.value })}
                            autoComplete="new-password"
                            required
                        />
                        <FontAwesomeIcon icon={faLock} className="auth-input-icon" />
                        <button
                            type="button"
                            className="auth-input-action"
                            onClick={() => setShowPassword(!showPassword)}
                            aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                        >
                            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                        </button>
                    </div>

                    <div className="auth-input-group mb-3">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            className="auth-input"
                            placeholder="Repetir contraseña"
                            value={formData.repeatPassword}
                            onChange={e => setFormData({ ...formData, repeatPassword: e.target.value })}
                            autoComplete="new-password"
                            required
                        />
                        <FontAwesomeIcon icon={faCheckCircle} className="auth-input-icon" />
                    </div>

                    <div className="auth-password-meter mb-4">
                        <div className="auth-password-meter-track">
                            <span style={{ width: `${passwordScore * 25}%` }} />
                        </div>
                        <small>{passwordScore >= 3 ? 'Seguridad alta' : 'Usa mayusculas, numeros y simbolos.'}</small>
                    </div>

                    <button type="submit" className="auth-btn-primary mb-4" disabled={loading}>
                        {loading ? <Spinner size="sm" animation="border" /> : (
                            <><FontAwesomeIcon icon={faShieldAlt} /> Actualizar contraseña</>
                        )}
                    </button>

                    <div className="auth-note">
                        El enlace se usa una sola vez. Al actualizar la contraseña volveras al login.
                    </div>
                </form>
            )}
        </div>
    );
};

export default ResetPassword;
